import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";
import {FloatLabel} from "primereact/floatlabel";
import {useState, useEffect} from "react";

export default function ProcessCancelationForm({
	selectedRow,
	cancellationDate,
	setCancellationDate,
	cancellationReason,
	setCancellationReason,
	setCancellationBtn,
}) {
	useEffect(() => {
		if ((cancellationDate === "", cancellationReason === "")) {
			setCancellationBtn(true);
		} else {
			setCancellationBtn(false);
		}
	}, [cancellationDate, cancellationReason]);

	console.log({cancellationDate}, {cancellationReason});

	const formatDate = date => {
		if (!date) return "";
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	};

	const handleDateChange = e => {
		setCancellationDate(formatDate(e.value));
	};

	return (
		<div className="col-12 p-0">
			<div className="border-bottom pb-3 fst-italic text-decoration-underline text-danger opacity-50 fw-bold fs-5">
				You are going to cancel the contract N {selectedRow?.formatted_contract_number} /{" "}
				{selectedRow.name}
			</div>
			<div className="row m-0 p-0 py-4">
				<div className="col-12 p-0 mb-5">
					<FloatLabel>
						<Calendar
							value={cancellationDate ? new Date(cancellationDate) : null}
							dateFormat="yy-mm-dd"
							placeholder="YYYY-MM-DD"
							onChange={handleDateChange}
						/>
						<label htmlFor="cancellationDate">Cancellation Date</label>
					</FloatLabel>
				</div>
				<div className="col-12 p-0 mb-5">
					<FloatLabel>
						<InputTextarea
							value={cancellationReason}
							onChange={e => setCancellationReason(e.target.value)}
							rows={5}
							autoResize
						/>
						<label htmlFor="cancellationReason">
							Reason for cancellation: Please describe why you are canceling the{" "}
							{selectedRow?.formatted_contract_number} / {selectedRow.name} contract.
						</label>
					</FloatLabel>
				</div>
			</div>
		</div>
	);
}
